export const NAME = "paymentMethodProfilesPage" as const;
